<template>
  <div>
    <!-- -->
    <div class="bluesection">            
      <img
        id="tplogo"
        src="img/transplus.png"
        alt=""
        class="adlogo"
      >                  
      <h2 class="title">
        Contact Us
      </h2>
    </div>    

    <div class="section">
      <div class="container">
        <div class="col-md-5  ml-auto mr-auto ">
          <form id="contact-form">                
            <div class="row">
              <label v-html="$t('Contact.Name')">Name</label>
              <input
                v-model="Contact.Name"
                type="name"
                aria-describedby="addon-right addon-left"
                class="custom_form"
              >

              <label :class="{ 'custom_form error': $v.data.DIVISION.$error }">Company</label>
              <input
                v-model="Contact.Company"
                type="company"
                aria-describedby="addon-right addon-left"
                class="custom_form"
              >

              <label v-html="$t('Contact.Phone')">Phone Number</label>
              <input
                v-model="Contact.Phone"
                type="phone"
                aria-describedby="addon-right addon-left"
                class="custom_form"
              >

              <label v-html="$t('Contact.Email')">Email</label>
              <input
                v-model.trim="$v.Contact.Email.$model"
                type="email"
                aria-describedby="addon-right addon-left"
                class="custom_form"
                :class="{ 'custom_form error': $v.Contact.Email.$error }"
              >

              <!--
                  <select id="form_need" aria-describedby="addon-right addon-left" class="custom_form" v-model="data.DIVISION"  :class="{ 'custom_form error': $v.data.DIVISION.$error }" v-model.trim="$v.data.DIVISION.$model">
                    <option value="" disabled selected></option>                                                                       
                    <option value="WAREHOUSE"  v-html="$t('Contact.Warehousing')">Warehousing</option>
                    <option value="TRANSPORT"  v-html="$t('Contact.Transportation')">Transportation</option>
                    <option value="GENERAL INQUIRY"  v-html="$t('Contact.GenInq')">General Inquiry</option>
                  </select>                
                  -->
                  
              <label>A brief description of your warehousing needs & best time to contact you</label>
              <textarea
                v-model="data.Message"
                v-model.trim="$v.data.Message.$model"
                class="custom_form"
                rows="4"
                required="required"
                data-error="Type Message Here "
                style="height:200px"
                :class="{ 'error': $v.data.Message.$error }"
              />                                
              <small>({{ data.Message.length }} / 20) *Minimum 20 characters</small>

              <div style="width:100%;">
                <div class="text-center">
                  <button
                    type="button"
                    class="btnBlue"
                    @click="sendmessage"
                  >
                    <!---->SUBMIT<!---->
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { required, email,minLength } from 'vuelidate/lib/validators'

export default {
  validations: {
    Contact: {
      Name: { required },
      Phone: { required },        
      //Department: { required },
      Email: { required, email }
    },
    data:{    
      DIVISION: { required },
      Message: { minLength: minLength(20) }
    }
  },  
  data() {
    return {    
      year: new Date().getFullYear(),
      Contact: {
        Name: '',
        Company: '',
        Phone: '',
        Email: ''
      },
      data:{
        DIVISION: 'WAREHOUSE',
        Message: ''
      },    
    };
  },
  mounted: function (){
           
  },
  created: function(){     
    
  },
  methods:{

    sendmessage() {
        
        this.$v.Contact.$touch();
        // if its still pending or an error is returned do not submit
        if (this.$v.Contact.Email.$error || this.$v.data.Message.$error || this.$v.data.DIVISION.$error) {        
          return;
        }
        
        axios.post('https://api.transplus.com/adContact/', {data: this.data, contact: this.Contact, subject: 'Warehouse & 3PL Inquiry ⭐'} )
        .then((response) => {
          this.$router.push('/thankyou');        
        })
        .catch(e => {
          alert(e)
          console.log(e)
        })
         
    }
  }
};
</script>

<style scoped>
::placeholder {
  color: rgb(205, 205, 205);
}
label {
  margin-top:15px;
}
.adlogo {
    height:60px; 
    filter: brightness(0) invert(1);
}
.custom_form {
  
  border:1px solid #333;
  width: 100%;
  padding: 12px 20px;
  margin-bottom: 8px;
  box-sizing: border-box;
}

.custom_form:focus {
  outline: none !important;
  border:1px solid #55B550;
  box-shadow: 0 0 4px #55B550;
}

.error {
  border:1px solid #800020;
  box-shadow: 0 0 4px #800020 ;
}


.hoverblue {
  color: #999;
  background-color: rgb(245, 245, 245);
  border-width: 0;
  font-weight: bold;
  font-size: 12px;    
  margin: 20px 1px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.hoverblue:hover{
  color: white;
  background-color: dodgerblue;
}

.negative-section{
  
  /*
    width:100%;
    margin-left: auto;
    margin-right: auto;
    margin-top: -100px;
    height:400px;    
    z-index:99;
  */    
}
.btnBlue{
  background-color:dodgerblue;
  text-align:center;
  border-radius: 5px;
  border-style: solid;
  border-color: dodgerblue;  
  color: white;
  font-size: 1.6em;
  width:200px;
  margin:5px;
  transition: width 1s;
  padding: 11px 22px 11px 22px;  
}
.btnBlue:hover {
  background-color:#58a8f5;
}
.turngreen {
  transition: 0.3s;
  margin:10px;
}
.turngreen:hover {
   background-color:#55B550; 
   color:white; 
   border-radius: 5px;
   margin-bottom:10px;
}

@media only screen and (max-width: 600px) {  
  .negative-section{
      text-align:center;
  }
}

</style>
